import VueApolloComponents from "@vue/apollo-components";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueApolloComponents);
});
